import type { ImagesSizes } from 'product-card/context/ProductCardImagesSizesContext/ProductCardImagesSizesContext'
import { ColumnLayout } from 'product-card/types'

const oneColumns: ImagesSizes[] = [
	{
		maxWidth: '600px',
		size: '100vw',
	},
	{
		size: '480px',
	},
]

const twoColumns: ImagesSizes[] = [
	{
		maxWidth: '1024px',
		size: 'calc(50vw - 0.5px)',
	},
	{
		size: '511.5px',
	},
]

const twoColumnsFeatured: ImagesSizes[] = [
	{
		maxWidth: '1024px',
		size: '100vw',
	},
	{
		size: '1024px',
	},
]

const fourColumns: ImagesSizes[] = [
	{
		size: '25vw',
	},
]

const fourColumnsFeatured: ImagesSizes[] = [
	{
		size: '50vw',
	},
]

const featured: { [x: number]: ImagesSizes[] } = {
	[ColumnLayout.TwoColumns]: twoColumnsFeatured,
	[ColumnLayout.FourColumns]: fourColumnsFeatured,
}

const regular: { [x: number]: ImagesSizes[] } = {
	[ColumnLayout.TwoColumns]: twoColumns,
	[ColumnLayout.FourColumns]: fourColumns,
}

export const imagesSizesByLayout: {
	[x: number]: { regular: ImagesSizes[]; featured: ImagesSizes[] }
} = {
	[ColumnLayout.OneColumn]: {
		regular: oneColumns,
		featured: oneColumns,
	},
	[ColumnLayout.TwoColumns]: {
		regular: regular[ColumnLayout.TwoColumns],
		featured: featured[ColumnLayout.TwoColumns],
	},
	[ColumnLayout.FourColumns]: {
		regular: regular[ColumnLayout.FourColumns],
		featured: featured[ColumnLayout.FourColumns],
	},
}
